/**
 * this is a modal
 *
 * @parent anybody
 * @stateful
 * @children Footer, Header
 */
import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import './style.scss'
import Header from "./Header"
import Footer from "./Footer"
import keydown, { ALL_KEYS } from 'react-keydown';
import Loading from 'components/UI/Loading';
import Transition from 'components/UI/Transition';
import { browserHistory } from 'react-router';

const HAS_HEADER = false;
const HAS_FOOTER = false;
const ALLOW_CLOSE_BY_CLICKING_SHADOW = true;

class CustomModal extends React.Component {
  constructor(props) {
    super(props)
		this.state = {
			style: {},
			overlayStyle: {},
			open: false,
		}

		this.closeModal = this.closeModal.bind(this);
    this.listenToKeys = this.listenToKeys.bind(this);
    this.forceCloseModal = this.forceCloseModal.bind(this);

    
    this.setActionsWhenRouteChanges(props)
  }

  setActionsWhenRouteChanges(props) {
    browserHistory.listen((location)=> {
      this.forceCloseModal();
    });
  }

  static defaultProps = {
    allowEscKeyToClose: true,
  }

	static propTypes = {
		// default is false. If true, the default closing button will be hidden and
		// you'd have to pass onCloseModalClick function as prop to handle closing action
    allowEscKeyToClose: PropTypes.bool,
    useDefaultCloseButton: PropTypes.bool,
		isShowingModal: PropTypes.bool,
		allowCloseByClickingShadow: PropTypes.bool,

		onCloseModalClick: PropTypes.func,
		fixedHeight: PropTypes.number,
		fixedWidth: PropTypes.number,
		overlayColor: PropTypes.string,
		overlayOpacity: PropTypes.number,

		// props for Footer
		footerType: PropTypes.string, // grey, transparent
		footerButtons: PropTypes.array,
		footerClassName: PropTypes.string,
		footerCustomContent: PropTypes.object, // it will be over the footer content

		// props for Header
		headerType: PropTypes.string,
		headerClassName: PropTypes.string,
    headerTitle: PropTypes.string,
		headerIcon: PropTypes.string,
		headerCustomContent: PropTypes.object,
	}

  @keydown(ALL_KEYS)
  listenToKeys(e) {
    if (this.props.allowEscKeyToClose) {
      if (e.code === 'Escape') {
        this.closeModal();
      }
    }
  }

  forceCloseModal() {
    if (typeof this.props.dismiss === 'function') {
      this.props.dismiss();
    }
    this.setState({
      open: false,
    });
  }

	closeModal() {
		let {
			onCloseModalClick
		} = this.props;

		if (typeof onCloseModalClick == "function") {
			onCloseModalClick();
		} else {
      this.setState({
        open: false,
      });
    }
	}

	componentWillMount() {
		let style = {}
		let overlayStyle = {}
		let {
			isShowingModal,
			fixedHeight,
			fixedWidth,
      overlayColor,
      overlayOpacity,
		} = this.props

		if (fixedHeight) {
			style.height = fixedHeight;
		}
		if (fixedWidth) {
			style.width = fixedWidth;
		}

		if (overlayColor) {
			overlayStyle.backgroundColor = overlayColor;
		}

    if (overlayOpacity) {
			overlayStyle.opacity = overlayOpacity;
		}

		this.setState({
      style,
      overlayStyle,
			open: isShowingModal
		});
	}

	componentWillReceiveProps(nextProps) {

		let {
			open
		} = this.state;

		// Note that we expect exact booleans
		if (nextProps.isShowingModal === false) {
			this.setState({
				open: false
			});
		}

		if (nextProps.isShowingModal === true) {
			this.setState({
				open: true
			});
		}
	}

  render() {
		let {
			isShowingModal,
			useDefaultCloseButton,
			hasHeader,
			hasFooter,
			footerType,
			footerClassName,
			height,
      contentHeight,
      loading,
      getContentRef,
      allowCloseByClickingShadow = ALLOW_CLOSE_BY_CLICKING_SHADOW,
		} = this.props;

		let {
      style,
      overlayStyle,
		} = this.state;

		if (typeof hasHeader == "undefined") {
			hasHeader = HAS_HEADER;
		}

		if (typeof hasFooter == "undefined") {
			hasFooter = HAS_FOOTER;
    }

    const children = React.Children.map(this.props.children || this.props.modalContent, child => React.cloneElement(child, { contentRef: this.contentRef, }));

		return (
        <div className={ classnames('classtop-custom-modal', this.props.className, { 'shown': this.state.open }) }>
            <div
              className="overlay"
              onClick={allowCloseByClickingShadow && !loading && this.closeModal} style={overlayStyle}></div>
          {
          this.state.open &&
            <div className="modal-float-body" style={style}>
            <Transition type='expand'>
              <div className={classnames("content-wrapper", { 'loading': loading, })}>
                { loading && <Loading /> }
                <div className='content'>
                { hasHeader && <Header {...this.props} closeModal={this.closeModal} /> }

                { isShowingModal && <div className="classtop-modal-wrapper">
                  <div style={{ height: contentHeight || "auto"}} className="classtop-modal-content" ref={(r)=>{
                      if (r) this.contentRef = r;
                      if (typeof getContentRef === 'function') {
                        getContentRef(r);
                      }
                   }}>
                      {children}
                    </div>
                  </div> }

                { hasFooter && <Footer {...this.props} /> }
                </div>
              </div>
            </Transition>
            </div>
          }
        </div>
    )
  }
}


export default CustomModal



// WEBPACK FOOTER //
// ./src/components/UI/Modal/index.js